exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container{margin-right:auto;margin-left:auto;padding:0 50px;width:100%}dl{width:100%}dl,dl dt{display:inline-block}dl dt{float:left;margin-right:20px}.settings-account__avatar:after{border:none;background:none}", ""]);

// exports
